import { useEffect } from "react";
import { useForm } from "../../useForm";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";

const initialFValues = {
  name: "",
  display_name: "",
  dc_number: "",
  bill_addr_line1: "",
  bill_addr_city: "",
  bill_addr_postal_code: "",
  bill_addr_country_sub_division_code: "",
  ship_addr_line1: "",
  ship_addr_city: "",
  ship_addr_postal_code: "",
  ship_addr_country_sub_division_code: "",
  quickbooks_id: "",
};

export default function SunCustomersForm(props) {
  const { index, sunCustomer, setOpen, actionCall, isEdit } = props;

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, false);

  const validateForm = () => {
    const newErrors = {};

    if (!values.name.trim()) {
      newErrors.name = "Location name is required";
    }

    if (!values.display_name.trim()) {
      newErrors.display_name = "Display name is required";
    }

    if (!values.bill_addr_line1.trim()) {
      newErrors.bill_addr_line1 = "Billing address is required";
    }

    if (!values.bill_addr_city.trim()) {
      newErrors.bill_addr_city = "Billing city is required";
    }

    if (!values.bill_addr_country_sub_division_code.trim()) {
      newErrors.bill_addr_country_sub_division_code =
        "Billing province is required";
    }

    if (!values.bill_addr_postal_code.trim()) {
      newErrors.bill_addr_postal_code = "Billing postal code is required";
    }

    if (!values.ship_addr_line1.trim()) {
      newErrors.ship_addr_line1 = "Shipping address is required";
    }

    if (!values.ship_addr_city.trim()) {
      newErrors.ship_addr_city = "Shipping city is required";
    }

    if (!values.ship_addr_country_sub_division_code.trim()) {
      newErrors.ship_addr_country_sub_division_code =
        "Shipping province is required";
    }

    if (!values.ship_addr_postal_code.trim()) {
      newErrors.ship_addr_postal_code = "Shipping postal code is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      if (isEdit) {
        actionCall(sunCustomer, values, index);
      } else {
        actionCall(values);
      }
    }
  };

  useEffect(() => {
    if (isEdit && sunCustomer) {
      setValues({
        name: sunCustomer.name || "",
        display_name: sunCustomer.display_name || "",
        dc_number: sunCustomer.dc_number || "",
        bill_addr_line1: sunCustomer.bill_addr_line1 || "",
        bill_addr_city: sunCustomer.bill_addr_city || "",
        bill_addr_postal_code: sunCustomer.bill_addr_postal_code || "",
        bill_addr_country_sub_division_code:
          sunCustomer.bill_addr_country_sub_division_code || "",
        ship_addr_line1: sunCustomer.ship_addr_line1 || "",
        ship_addr_city: sunCustomer.ship_addr_city || "",
        ship_addr_postal_code: sunCustomer.ship_addr_postal_code || "",
        ship_addr_country_sub_division_code:
          sunCustomer.ship_addr_country_sub_division_code || "",
        quickbooks_id: sunCustomer.quickbooks_id || "",
      });
    }
  }, [sunCustomer, setValues, isEdit]);

  return (
    <div className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              {isEdit && sunCustomer
                ? `Edit ${sunCustomer.name}`
                : "Add New SUN Customer"}
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6">
          <div className="mt-2">
            <Input
              label="Location Name *"
              name="name"
              onChange={handleInputChange}
              value={values.name}
              labelOn={true}
              type="text"
              error={errors.name}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="Display Name *"
              name="display_name"
              onChange={handleInputChange}
              value={values.display_name}
              labelOn={true}
              type="text"
              error={errors.display_name}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="DC Number *"
              name="dc_number"
              onChange={handleInputChange}
              value={values.dc_number}
              labelOn={true}
              type="text"
              error={errors.dc_number}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-4">
            <h3 className="text-m font-medium text-gray-900 mb-2">
              Billing Address
            </h3>
          </div>
          <div className="mt-2">
            <Input
              label="Street Address *"
              name="bill_addr_line1"
              onChange={handleInputChange}
              value={values.bill_addr_line1}
              labelOn={true}
              type="text"
              error={errors.bill_addr_line1}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="City *"
              name="bill_addr_city"
              onChange={handleInputChange}
              value={values.bill_addr_city}
              labelOn={true}
              type="text"
              error={errors.bill_addr_city}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="Province *"
              name="bill_addr_country_sub_division_code"
              onChange={handleInputChange}
              value={values.bill_addr_country_sub_division_code}
              labelOn={true}
              type="text"
              placeholder="e.g., Ontario"
              error={errors.bill_addr_country_sub_division_code}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="Postal Code *"
              name="bill_addr_postal_code"
              onChange={handleInputChange}
              value={values.bill_addr_postal_code}
              labelOn={true}
              type="text"
              placeholder="e.g., M8Z 2G9"
              error={errors.bill_addr_postal_code}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-4">
            <h3 className="text-m font-medium text-gray-900 mb-2">
              Shipping Address
            </h3>
          </div>
          <div className="mt-2">
            <Input
              label="Street Address *"
              name="ship_addr_line1"
              onChange={handleInputChange}
              value={values.ship_addr_line1}
              labelOn={true}
              type="text"
              error={errors.ship_addr_line1}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="City *"
              name="ship_addr_city"
              onChange={handleInputChange}
              value={values.ship_addr_city}
              labelOn={true}
              type="text"
              error={errors.ship_addr_city}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="Province *"
              name="ship_addr_country_sub_division_code"
              onChange={handleInputChange}
              value={values.ship_addr_country_sub_division_code}
              labelOn={true}
              type="text"
              placeholder="e.g., Ontario"
              error={errors.ship_addr_country_sub_division_code}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="Postal Code *"
              name="ship_addr_postal_code"
              onChange={handleInputChange}
              value={values.ship_addr_postal_code}
              labelOn={true}
              type="text"
              placeholder="e.g., M8Z 2G9"
              error={errors.ship_addr_postal_code}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="Quickbooks Id"
              name="quickbooks_id"
              onChange={handleInputChange}
              value={values.quickbooks_id}
              labelOn={true}
              type="text"
              disabled={true}
              error={errors.quickbooks_id}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end px-4 py-4">
        <button
          type="button"
          className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
          onClick={() => setOpen({ childComponent: null, open: false })}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="ml-4 inline-flex justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={handleSubmit}
        >
          {isEdit ? "Save" : "Create"}
        </button>
      </div>
    </div>
  );
}
